import _ from 'lodash';
import React, {Component} from 'react';
import {Segment} from 'semantic-ui-react';
import {FemaGoTable} from 'app-ui-componentlibrary';
import {connect} from 'react-redux';
import ApiActions from 'go/actions/api';
import Dimmer from 'semantic-ui-react/dist/commonjs/modules/Dimmer/Dimmer';
import Loader from 'semantic-ui-react/dist/commonjs/elements/Loader/Loader';
import REST from 'go/requests/rest';
import {isFemaUser, getGroupName} from 'common/utils';
import {API_TASK_UNASSIGN_SUCCESS, API_TASK_ASSIGN_POST_SUCCESS} from 'common/types';
import {push} from 'react-router-redux';
import {PANEL_CHAIR_REVIEW} from 'app-ui-componentlibrary/dist/go/components/common/pageTitles';
import {forceJsonResponse, MONO, FLUX} from 'common/utils';
export class PendingPanelChairReviewList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      data: [],
      unassignedApplicationId: null,
      groups: [],
      tasks: [],
      suspended: false,
    };
  }

  loadElligableTasks = () => {
    const {token, userId, panelSessionId} = this.props;

    this.fetchSessionConfig(panelSessionId, 'aliases').then((config) => {
      this.setHeadersInState(config);
      //set the config to state
    });

    //TO DO: check the response from workflow and see what data is needed
    let getWorkflowPanelReviewChair = {};
    if (!_.isEmpty(this.props.permissions)) {
      getWorkflowPanelReviewChair.taskDefinitionKey = 'panelChair';
    }
    _.assign(getWorkflowPanelReviewChair, {
      processVariables: [
        {
          name: 'sessionId',
          operator: 'eq',
          value: +panelSessionId,
        },
      ],
    });

    //need to enable this task in config
    //possibly need to do by internal tasks? because this is an internal user? instead of external eligibletasks

    let totalTasks = [];
    return REST.workflow
      .getAllExternalEligibleTasks(
        token,
        [
          'sessionId',
          'grantId',
          'entityDisplay',
          'organizationName',
          'category',
          'groupId',
        ],
        {...getWorkflowPanelReviewChair, assignee: userId},
        500
      )
      .then((response) => forceJsonResponse(response, FLUX))
      .then((responseJson) => {
        totalTasks = responseJson;
      })
      .then(() => {
        if (!this.state.suspended) {
          REST.workflow
            .getAllExternalEligibleTasks(
              token,
              [
                'sessionId',
                'grantId',
                'entityDisplay',
                'organizationName',
                'category',
                'groupId',
              ],
              {...getWorkflowPanelReviewChair, unassigned: true},
              500
            )
            .then((response) => forceJsonResponse(response, FLUX))
            .then((responseJson) => {
              this.setState({
                tasks: [...totalTasks, ...responseJson],
                loading: false,
                error: false,
              });
            })
            .catch((err) => {
              this.setErrorState(err);
            });
        }
      })
      .catch((err) => {
        this.setErrorState(err);
      });
  };

  componentDidMount() {
    document.title = PANEL_CHAIR_REVIEW;
    const {panelSessionId, userId, token, groups} = this.props;

    REST.panelReviewV2
      .getChairBySessionAndId(token, panelSessionId, userId)
      .then((response) => forceJsonResponse(response, MONO))
      .then((responseJson) => {
        this.setState({
          suspended: _.get(responseJson, 'suspended', true),
        });
      });
    this.loadElligableTasks();
    this.fetchGroup(panelSessionId).then((groups) => this.setState({groups: groups}));
  }

  fetchSessionConfig = (panelSessionId, taskDefKey) => {
    const {token} = this.props;
    return REST.panelReviewV2
      .getPanelSessionConfiguration(token, panelSessionId, taskDefKey)
      .then(REST.handler.handleResponse);
  };

  fetchGroup = (panelSessionId) => {
    const {token} = this.props;
    return REST.panelReviewV2
      .getGroupsBySession(token, panelSessionId)
      .then(REST.handler.handleResponse);
  };

  setHeadersInState(config) {
    _.map(config, (aliases) => {
      _.map(aliases, (alias) => {
        this.setState({
          [_.get(alias, 'value')]: _.get(alias, 'label'),
        });
      });
    });
    this.setState({
      aliases: config,
    });
  }

  setErrorState = (error) => {
    console.error(error);
    this.setState({
      loading: false,
      error: true,
    });
  };

  handleButtonClick = () => {};

  renderAssignee = (id, assignedUserId, assignedProfile = {}, entityDisplay) => {
    const {userId} = this.props;
    const {
      emailAdr: assignedEmail,
      firstName: assignedFirst,
      lastName: assignedLast,
    } = assignedProfile;

    const unassignLink = assignedUserId && (
      <a
        href={`#${id}`}
        title={`${entityDisplay}`}
        onClick={() => this.handleUnassignTask(id)}
        aria-label="Unassign"
      >
        (Unassign)
      </a>
    );
    const userDisplay = assignedUserId === userId ? 'You' : 'Unassigned';
    return (
      <React.Fragment>
        {userDisplay} {unassignLink}
      </React.Fragment>
    );
  };

  renderAction = (task) => {
    const {userId, panelSessionId, navigateToTask} = this.props;
    const {assignee, id} = task;
    switch (assignee) {
      case null:
        return (
          <a
            href={`#${id}`}
            title={`${task.entityDisplay}`}
            onClick={() => this.handleAssignTask(id)}
            aria-label="Start task"
          >
            Start task >
          </a>
        );
      case userId:
        return (
          <a
            href={`#${id}`}
            title={`${task.entityDisplay}`}
            onClick={() => navigateToTask(id, panelSessionId)}
            aria-label="Continue task"
          >
            Continue task >
          </a>
        );
      default:
        return;
    }
  };

  handleAssignTask = (id) => {
    const {assignTask, token, navigateToTask, panelSessionId} = this.props;
    assignTask(token, id).then((res) => {
      if (res && res.type === API_TASK_ASSIGN_POST_SUCCESS) {
        navigateToTask(id, panelSessionId);
      }
    });
  };

  handleUnassignTask = (id) => {
    const {unassignTask, token} = this.props;
    const {tasks} = this.state;
    unassignTask(token, id).then((res) => {
      if (res && res.type === API_TASK_UNASSIGN_SUCCESS) {
        _.find(tasks, (task) => task.id === id).assignee = null;
        this.setState({tasks});
      }
    });
  };

  render() {
    const {tasks, loading, error, groups} = this.state;
    if (loading) {
      return (
        <Dimmer active inverted>
          <Loader inverted />
        </Dimmer>
      );
    } else if (error) {
      return this.renderNoApplications();
    } else {
      return (
        <React.Fragment>
          <h2>Panel Chair Review</h2>
          <Segment className="panel-review-dashboard">
            <FemaGoTable type="static" summary="Panel Chair Review">
              <FemaGoTable.Header>
                <FemaGoTable.Row>
                  <FemaGoTable.HeaderCell>
                    {_.get(this.state, 'organization', 'Applicant')}
                  </FemaGoTable.HeaderCell>
                  <FemaGoTable.HeaderCell>
                    {_.get(this.state, 'id', 'Application ID')}
                  </FemaGoTable.HeaderCell>
                  <FemaGoTable.HeaderCell>
                    {_.get(this.state, 'category', 'Application Category Type')}
                  </FemaGoTable.HeaderCell>
                  <FemaGoTable.HeaderCell type="text">
                    {_.get(this.state, 'groupId', 'Group Number')}
                  </FemaGoTable.HeaderCell>
                  <FemaGoTable.HeaderCell>Assigned To</FemaGoTable.HeaderCell>
                  <FemaGoTable.HeaderCell>Action</FemaGoTable.HeaderCell>
                </FemaGoTable.Row>
              </FemaGoTable.Header>
              <FemaGoTable.Body>
                {_.map(tasks, (task) => {
                  const groupName = getGroupName(groups, task.groupId);
                  return (
                    <FemaGoTable.Row key={task.organizationName}>
                      <FemaGoTable.TextCell>{task.organizationName}</FemaGoTable.TextCell>
                      <FemaGoTable.TextCell>{task.entityDisplay}</FemaGoTable.TextCell>
                      <FemaGoTable.TextCell>{task.category}</FemaGoTable.TextCell>
                      <FemaGoTable.TextCell>{groupName}</FemaGoTable.TextCell>
                      <FemaGoTable.TextCell>
                        {this.renderAssignee(
                          task.id,
                          task.assignee,
                          task.profile,
                          task.entityDisplay
                        )}
                      </FemaGoTable.TextCell>
                      <FemaGoTable.TextCell>
                        {this.renderAction(task)}
                      </FemaGoTable.TextCell>
                    </FemaGoTable.Row>
                  );
                })}
              </FemaGoTable.Body>
            </FemaGoTable>
          </Segment>
        </React.Fragment>
      );
    }
  }

  renderNoApplications() {
    return <Segment>No applications were found.</Segment>;
  }
}

export const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
    jwt: state.auth.token,
    permissions: state.auth.permissions,
    userId: state.auth.userId,
    firstName: state.profile.firstName,
    lastName: state.profile.lastName,
    hasFemaPermissions: isFemaUser(state.auth.permissions),
    email: state.profile.emailAdr,
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    unassignTask: (token, id) => {
      const action = ApiActions.tasks.unassignTask(token, id);
      const response = dispatch(action);
      return response;
    },
    assignTask: (token, id) => {
      const action = ApiActions.tasks.assignTask(id, token);
      const response = dispatch(action);
      return response;
    },
    navigateToTask: (taskId, sessionId) => {
      dispatch(push('/panelReview/sessions/' + sessionId + '/tasks/' + taskId));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PendingPanelChairReviewList);
